import { useEffect, useRef } from 'react';
import { debeBajar, elementoQueDesplaza, estaAbajo } from '../lib/chatScroll';

/**
 * Baja el chat al final solo cuando toca (lib/chatScroll): al abrir la conversación y con un
 * mensaje nuevo si estaba abajo o si es suyo. El refresco de cada 5 segundos ya no lo mueve.
 *
 * `mensajes` va del más viejo al más nuevo. `conversacion` es lo que identifica el hilo
 * abierto: al cambiar, cuenta como abrirlo de nuevo.
 */
export default function useChatScroll(raizRef, mensajes, miId, conversacion) {
    const abajoRef = useRef(true);
    const ultimoRef = useRef(null);
    const conversacionRef = useRef(undefined);

    // Recordar si está abajo mientras se desplaza.
    useEffect(() => {
        const el = elementoQueDesplaza(raizRef.current);
        if (!el) return undefined;
        const alDesplazar = () => { abajoRef.current = estaAbajo(el); };
        el.addEventListener('scroll', alDesplazar, { passive: true });
        return () => el.removeEventListener('scroll', alDesplazar);
    });

    useEffect(() => {
        const el = elementoQueDesplaza(raizRef.current);
        const lista = mensajes || [];
        const ultimo = lista[lista.length - 1];
        const primera = conversacionRef.current !== conversacion;
        const bajar = debeBajar({
            primera: primera && lista.length > 0,
            ultimoAntes: ultimoRef.current,
            ultimoAhora: ultimo?.id ?? null,
            estabaAbajo: abajoRef.current,
            esMio: Boolean(miId) && ultimo?.sender_id === miId,
        });
        if (lista.length > 0) {
            conversacionRef.current = conversacion;
            ultimoRef.current = ultimo?.id ?? null;
        }
        if (bajar && el) {
            el.scrollTop = el.scrollHeight;
            abajoRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mensajes, conversacion]);
}
